import Resource from '@/api/resources/Resource'

class ResponsabilitiesConfigurationServices extends Resource {
    async getResponsibilities() {
        const response = await this.axios.get(`/configuration/responsibilities`)
        return response.data
    }
}

export default new ResponsabilitiesConfigurationServices()
